'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _resetPasswordFrompin = require('./reset-password-frompin.service');

var _resetPasswordFrompin2 = _interopRequireDefault(_resetPasswordFrompin);

var _resetPasswordFrompin3 = require('./reset-password-frompin.component');

var _resetPasswordFrompin4 = _interopRequireDefault(_resetPasswordFrompin3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.auth.resetPasswordFromPin', [_angularUiRouter2.default]).component('resetPasswordFromPin', _resetPasswordFrompin4.default).service('ResetPasswordFromPinService', _resetPasswordFrompin2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('resetPasswordFromPin', {
    parent: 'auth',
    url: '/reset-password-frompin',
    params: {
      userName: null
    },
    component: 'resetPasswordFromPin',
    resolve: {
      layout: function layout() {
        return 'column';
      },
      flex: function flex() {
        return '100';
      },
      credentials: function credentials($stateParams) {
        return {
          UserName: $stateParams.userName
        };
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/auth/reset-password-frompin/reset-password-frompin.module.js